export const navigateEvents = {
  BEFORE_RENDER: "NAVIGATE:BEFORE_RENDER",
  AFTER_RENDER: "NAVIGATE:AFTER_RENDER"
};
